import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Renders a full legal document (privacy or terms) from structured content.
export default function LegalContent({ data, id, standalone = false }) {
  return (
    <section id={id} className="bg-black py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-5 md:px-8">
        {standalone && (
          <Link
            to="/"
            data-testid="legal-back-home"
            className="mb-8 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-white/60 transition-colors hover:text-white"
          >
            <ArrowLeft size={16} /> Home
          </Link>
        )}

        <h1 className="font-display text-5xl leading-[0.95] tracking-tight text-white md:text-6xl">
          {data.title}
        </h1>
        <p className="mt-3 text-sm uppercase tracking-wider text-white/40">{data.updated}</p>

        {!standalone && (
          <Link
            to={id === "privacy" ? "/privacy" : "/terms"}
            className="mt-4 inline-block text-sm font-bold uppercase tracking-wider text-brand-orange hover:underline"
          >
            {id === "privacy" ? "Open as dedicated page →" : "Open as dedicated page →"}
          </Link>
        )}

        <p className="mt-8 border-l-2 border-brand-orange pl-5 text-lg leading-relaxed text-gray-300">
          {data.intro}
        </p>

        <div className="mt-10 space-y-10">
          {data.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-2xl tracking-tight text-white md:text-3xl">
                {s.title}
              </h2>
              <div className="mt-4 space-y-4">
                {s.content.map((block, j) => {
                  if (block.ul) {
                    return (
                      <ul key={j} className="space-y-2 pl-1">
                        {block.ul.map((li, k) => (
                          <li key={k} className="flex gap-3 leading-relaxed text-gray-400">
                            <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-brand-orange" />
                            <span>{li}</span>
                          </li>
                        ))}
                      </ul>
                    );
                  }
                  return (
                    <p key={j} className="leading-relaxed text-gray-400">
                      {block.p}
                    </p>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
